var AkrolabMenu = {
    init:function(){
        // Hide burger menu on en-uk pages
        if (window.location.href.includes("detectivebox.com/en-uk") && window.innerWidth <= 1200) {
            document.querySelector(".akrolab-menu .btn-open").style.display = "none";
            return; // Exit the function early to prevent any menu behavior
        }

        window.addEventListener("resize", function(){
            AkrolabMenu.resize();
        });
        
        if (window.innerWidth > 1200) {
            document.querySelectorAll(".akrolab-menu__menu-container").forEach(function (menu) {
                menu.addEventListener("click", function () {
                    if (menu.classList.contains("open")) {
                        AkrolabMenu.close_menu(menu);
                    } else {
                        AkrolabMenu.open_menu(menu);
                    }
                });
            });
        }

        document.querySelector(".akrolab-menu .btn-open").addEventListener("click", function(){
            AkrolabMenu.open_menuMobile();
        });

        document.querySelector(".akrolab-menu .btn-close").addEventListener("click", function(){
            AkrolabMenu.close_menuMobile();
        });
    },

    open_menu:function(menu){
        if (window.innerWidth > 1200) {
            document.querySelector("body").classList.add("menu-open");
            document.querySelectorAll(".akrolab-menu__menu-container").forEach(function(all_menu){
                all_menu.classList.remove("open");
            });
            menu.classList.add("open");
        }
    },
    
    close_menu:function(menu){
        document.querySelector("body").classList.remove("menu-open");
        menu.classList.remove("open");
    },
    
    open_menuMobile:function(){
        // Prevent opening menu on en-uk pages
        if (window.location.href.includes("detectivebox.com/en-uk")) {
            return; // Do nothing if it's an en-uk page
        }

        document.querySelector("body").classList.add("menu-open");
        document.querySelector(".akrolab-menu").classList.add("open");
        document.querySelector(".akrolab-menu__menu-container:nth-child(2)").classList.add("open");
    },
    
    close_menuMobile:function(){
        document.querySelector("body").classList.remove("menu-open");
        document.querySelector(".akrolab-menu").classList.remove("open");
    },
    
    resize:function(){
        document.querySelector("body").classList.remove("menu-open");
        document.querySelector(".akrolab-menu").classList.remove("open");
        document.querySelectorAll(".akrolab-menu__menu-container").forEach(function(all_menu){
            all_menu.classList.remove("open");
        });
    }
}

AkrolabMenu.init();